import { render, staticRenderFns } from "./HorseFiche.vue?vue&type=template&id=29a73c20&"
import script from "./HorseFiche.vue?vue&type=script&lang=js&"
export * from "./HorseFiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports